import { Box, Divider, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTenant } from 'probonio-shared-ui/module/me';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../redux/hooks';
import probonioLogo from './logo.svg';
import probonioLogoDark from './logoDark.svg';
import probonioLogoPlain from './logoPlain.svg';
import probonioLogoPlainDark from './logoPlainDark.svg';

interface Props {
  plain?: boolean;
  height?: number;
  /** Rendered below the portal title, which then always reads "Probonio Arbeitgeber-Portal" as in the wide header. */
  subtitle?: React.ReactNode;
}

export const BrandLogo: React.FC<Props> = ({ plain, height, subtitle }) => {
  const { t } = useTranslation('navigationModule');
  const { tenant } = useTenant();

  const currentUser = useAppSelector(state => state.me.user);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const isDarkMode = theme.palette.mode === 'dark';

  const SIMON_MAIL = 'simon@tiffinger-thiel.de';
  const SIMON_LOGO = '/image/demo_logo.png';
  let tenantLogo = isDarkMode ? tenant?.imageURLDark : tenant?.imageURL;
  if (currentUser?.mail === SIMON_MAIL) {
    tenantLogo = SIMON_LOGO;
  }

  const brandLogo = plain ? (isDarkMode ? probonioLogoPlainDark : probonioLogoPlain) : isDarkMode ? probonioLogoDark : probonioLogo;

  return (
    <span style={isMobile ? { display: 'inline-block' } : {}}>
      <img
        data-test-id="brand-logo"
        src={tenantLogo || brandLogo}
        alt={t('brand')}
        style={{ verticalAlign: 'middle', maxHeight: height || '50px', maxWidth: 'min(100%, 300px)' }}
      />
      {!plain && (
        <>
          <Divider orientation="vertical" sx={{ height: 35, verticalAlign: 'middle', display: 'inline-block', marginX: 2 }} />
          {subtitle ? (
            <Box component="span" sx={{ display: 'inline-flex', flexDirection: 'column', verticalAlign: 'middle', minWidth: 0 }}>
              <Typography component="span" variant="h2">
                {t('titleFull')}
              </Typography>
              {subtitle}
            </Box>
          ) : (
            <Typography sx={{ verticalAlign: 'middle' }} component="span" variant="h2">
              {t(tenantLogo && !isMobile ? 'titleFull' : 'title')}
            </Typography>
          )}
        </>
      )}
    </span>
  );
};
